/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class ProductSpec extends React.Component {
	render() {
		return (
            <div>
				{this.props.children}
            </div>
		)
	}
}
;
export default ProductSpec;


// WEBPACK FOOTER //
// ./src/routes/productSpec/index.js